/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ApiResultDto } from '../models/api-result-dto';
import { VerificationTokenEmail } from '../models/verification-token-email';

@Injectable({
  providedIn: 'root',
})
export class VerificationTokenControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation verificationTokenControllerSendPiNtoVerifyPhoneNumber
   */
  static readonly VerificationTokenControllerSendPiNtoVerifyPhoneNumberPath = '/verification-tokens/send-pin-to-verify-phone-number';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendPINtoVerifyPhoneNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendPINtoVerifyPhoneNumber$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, VerificationTokenControllerService.VerificationTokenControllerSendPiNtoVerifyPhoneNumberPath, 'patch');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendPINtoVerifyPhoneNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendPINtoVerifyPhoneNumber(params?: {
  }): Observable<void> {

    return this.sendPINtoVerifyPhoneNumber$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation verificationTokenControllerSendTokenToVerifyEmail
   */
  static readonly VerificationTokenControllerSendTokenToVerifyEmailPath = '/verification-tokens/send-token-to-verify-email';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendTokenToVerifyEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendTokenToVerifyEmail$Response(params?: {
    body?: VerificationTokenEmail
  }): Observable<StrictHttpResponse<ApiResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, VerificationTokenControllerService.VerificationTokenControllerSendTokenToVerifyEmailPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApiResultDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendTokenToVerifyEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendTokenToVerifyEmail(params?: {
    body?: VerificationTokenEmail
  }): Observable<ApiResultDto> {

    return this.sendTokenToVerifyEmail$Response(params).pipe(
      map((r: StrictHttpResponse<ApiResultDto>) => r.body as ApiResultDto)
    );
  }

}
